/* eslint-disable import/no-named-as-default-member */
/* eslint-disable import/no-named-as-default */
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { QueryClientProvider } from '@tanstack/react-query';
import reportWebVitals from './reportWebVitals';
import { store } from './store/Store';
import queryClient from './queryClient';
import { ContextProvider } from './context/authContext';
import { SearchContextProvider } from './context/searchContext';
import { SearchMatContextProvider } from './context/searchMatContext';
import App from './App';
import config from './config';
import './index.css';

// Filtrar tokens JWT de console.log (paquete auto-mat los imprime por error)
// eslint-disable-next-line no-console
const originalLog = console.log.bind(console);
// eslint-disable-next-line no-console
console.log = (...args) => {
  if (args.some((a) => typeof a === 'string' && (a.includes('tokenId') || a.startsWith('eyJ')))) return;
  originalLog(...args);
};

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <ContextProvider>
    <SearchContextProvider>
      <SearchMatContextProvider>
        <GoogleOAuthProvider clientId={config.REACT_APP_CLIENT_ID}>
          <QueryClientProvider client={queryClient}>
            <Provider store={store}>
              <BrowserRouter>
                <App />
              </BrowserRouter>
            </Provider>
          </QueryClientProvider>
        </GoogleOAuthProvider>
      </SearchMatContextProvider>
    </SearchContextProvider>
  </ContextProvider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals())
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
